/**
 * アプリケーションバージョン情報
 * ビルド時にvite.config.tsで環境変数として定義される
 * グローバル型定義はvite-env.d.tsで宣言済み
 */

/**
 * アプリケーションバージョン（セマンティックバージョニング）
 * 例: "0.1.0"
 */
export const APP_VERSION = __APP_VERSION__;

/**
 * Gitコミットハッシュ（短縮版）
 * 例: "abc1234"
 */
export const GIT_COMMIT_HASH = __GIT_COMMIT_HASH__;

/**
 * ビルド日時（ISO 8601形式）
 * 例: "2025-10-01T08:15:30.123Z"
 */
export const BUILD_DATE = __BUILD_DATE__;

/**
 * バージョン文字列を取得
 * 形式: "v{version}"
 * 例: "v0.1.0"
 */
export const getFullVersion = (): string => {
  return `v${APP_VERSION}`;
};

/**
 * ビルド日時を人間が読みやすい形式で取得
 * @param locale ロケール（デフォルト: 'ja-JP'）
 * @returns フォーマット済みビルド日時
 */
export const getFormattedBuildDate = (locale: string = 'ja-JP'): string => {
  const date = new Date(BUILD_DATE);
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
